<template>
  <div v-if="userPermission">
    <b-form>
      <div>
        <b-tabs no-nav-style nav-class="secondary-tabs">
          <b-tab
            :title="$t('tabs.general')"
            class="p-5"
            @click.prevent="updateVisibleSubmit(true)"
          >
            <statuses-form />
          </b-tab>
          <edit-actions
            route-name="statusesList"
            :is-visible-submit="isVisibleSubmit"
            @save="submit"
          />
        </b-tabs>
      </div>
    </b-form>
  </div>
  <div
    v-else
    class="w-100 h-100 d-flex align-items-center justify-content-center"
  >
    <p class="fs-18 font-weight-bold">
      {{ $t("messages.dont_have_permission") }}
    </p>
  </div>
</template>

<script>
import statusesForm from '@/components/statuses/form'
import editActions from '@/components/common/editActions'
import model from '@/models/statuses'
import permissions from '@/mixins/permissions'
import edit from '@/mixins/edit'
import api from '@/api/statuses'

export default {
  components: {
    statusesForm,
    editActions
  },
  mixins: [edit, permissions],
  data: () => ({
    api,
    loading: true,
    model: JSON.parse(JSON.stringify(model.empty)),
    rules: model.rules,
    isVisibleSubmit: true
  }),
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (this.$route.params.id) {
        await this.getItem()
      } else {
        this.initForm(this.model)
      }

      this.loading = false
    },
    updateVisibleSubmit(value) {
      this.isVisibleSubmit = value
    }
  },
  validations: {
    ...model.rules
  }
}
</script>

